import styled from 'styled-components';
import { breakpoints } from '@theme/breakpoints';

export const StyledAppSiteInfo = styled.div`
  display: flex;
  padding-bottom: 2rem;
`;
